import React, { JSX } from 'react'

const BUTTON_CLASS = 'rounded-md border border-white/10 px-2.5 py-1 text-xs text-dm-text-secondary hover:border-white/20 hover:text-dm-text-primary disabled:cursor-not-allowed disabled:opacity-60'

export const CursorPager = ({
  page,
  hasNext,
  loading,
  moreMayFollow = false,
  onPrev,
  onNext,
  testid
}: {
  page: number
  hasNext: boolean
  loading: boolean
  moreMayFollow?: boolean
  onPrev: () => void
  onNext: () => void
  testid?: string
}): JSX.Element => (
  <div className='mt-3 flex items-center justify-between gap-2' data-testid={testid}>
    <span className='text-[11px] tabular-nums text-dm-text-accent'>
      Page {page}
      {moreMayFollow && (
        <span className='ml-2 text-dm-text-secondary' data-testid={testid != null ? `${testid}-more` : undefined}>
          more may follow
        </span>
      )}
    </span>
    <div className='flex items-center gap-1.5'>
      <button
        type='button'
        onClick={onPrev}
        disabled={loading || page <= 1}
        aria-label='Previous page'
        data-testid={testid != null ? `${testid}-prev` : undefined}
        className={BUTTON_CLASS}
      >
        Prev
      </button>
      <button
        type='button'
        onClick={onNext}
        disabled={loading || !hasNext}
        aria-label='Next page'
        data-testid={testid != null ? `${testid}-next` : undefined}
        className={BUTTON_CLASS}
      >
        Next
      </button>
    </div>
  </div>
)
